import { useEffect } from 'react'
import { useBreadcrumbContext } from '../../context/breadcrumb.context'

// A page's whole trail in the admin's top bar (context/breadcrumb.context.js),
// as <PageTrail trail={[{ url, text, Icon?, block? }, ...]} />. Pages whose
// routes are siblings, not nested, name their whole trail (no ancestor route
// mounts the earlier crumbs): the LMS pages (view/lms-admin/lms-trail.js) and
// AI tools telemetry (layout/authorized/admin/ai-tools/ai-tools-trail.js). A
// crumb with block: true is a label that goes nowhere. A crumb whose name is
// still loading is passed as '' and is left out until the name arrives.
const NO_TOP_BAR = { addAll: () => {}, update: () => {}, remove: () => {} }

export const PageTrail = ({ trail }) => {
  // The admin always hosts the pages in a BreadcrumbProvider; a page rendered
  // on its own (a unit test) has no top bar to put a trail in.
  const breadcrumbContext = useBreadcrumbContext() || NO_TOP_BAR
  // A crumb whose name is empty or still loading is left out (no empty crumb, no
  // dangling separator); it joins the trail when its name arrives.
  const shown = trail.filter(crumb => typeof crumb.text === 'string' && crumb.text.trim() !== '')
  const urls = shown.map(crumb => crumb.url).join('|')
  const texts = shown.map(crumb => crumb.text).join('|')

  useEffect(
    () => {
      breadcrumbContext.addAll(shown)
      return () => shown.forEach(crumb => breadcrumbContext.remove(crumb.url))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [urls]
  )

  useEffect(
    () => {
      shown.forEach(crumb => breadcrumbContext.update(crumb.url, crumb.text, crumb.Icon, crumb.block))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [texts]
  )

  return null
}
